export enum InputType {
  TEXT = 0,
  TEXT_AREA = 1,
  NUMBER = 2,
  FILE = 3,
  COLOR_PICKER = 4,
  DATE = 5
}
